// InviteDone — thank-you page. Shown after a successful submit, also
// if an already-completed invitation is re-opened.

import { useEffect, useRef } from 'react'
import confetti from 'canvas-confetti'

// Vermillion, paper-cream, ink-navy — the book's palette.
const CONFETTI_COLORS = ['#E34234', '#F5EFE2', '#1A2135', '#C99A2E']

function fireCelebration() {
  const duration = 2200
  const end = Date.now() + duration
  const defaults = {
    startVelocity: 30,
    spread: 360,
    ticks: 60,
    zIndex: 50,
    colors: CONFETTI_COLORS,
  }
  ;(function frame() {
    const timeLeft = end - Date.now()
    if (timeLeft <= 0) return
    // Two side-bursts per frame — classic two-cannon volley.
    confetti({
      ...defaults,
      particleCount: 4,
      origin: { x: Math.random() * 0.3, y: Math.random() * 0.3 + 0.1 },
    })
    confetti({
      ...defaults,
      particleCount: 4,
      origin: { x: Math.random() * 0.3 + 0.7, y: Math.random() * 0.3 + 0.1 },
    })
    requestAnimationFrame(frame)
  })()
  // One big opening burst from centre-top.
  confetti({
    particleCount: 90,
    spread: 110,
    origin: { x: 0.5, y: 0.2 },
    colors: CONFETTI_COLORS,
    scalar: 1.1,
  })
}

export function InviteDone() {
  const firedRef = useRef(false)
  useEffect(() => {
    if (firedRef.current) return
    firedRef.current = true
    // Tiny delay so the page has painted before the cannons fire.
    const t = setTimeout(() => fireCelebration(), 180)
    return () => clearTimeout(t)
  }, [])

  return (
    <main className="min-h-screen bg-cream px-4 sm:px-6 py-10 sm:py-16">
      <div className="mx-auto max-w-xl space-y-8 text-center">
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
          Thank you
        </p>
        <h1 className="font-serif text-3xl sm:text-4xl leading-tight">
          That's it — your answers are in.
        </h1>
        <div className="font-serif text-lg leading-relaxed text-foreground/90 space-y-4">
          <p>
            I'll work these in by chapter rather than by person. Anything I
            plan to quote you on comes back to you first, word-for-word, before
            anything goes to print.
          </p>
          <p>
            If you thought of something else after closing the tab, email
            <a
              className="text-vermillion underline underline-offset-4 ml-1"
              href="mailto:stas@sliday.com"
            >
              stas@sliday.com
            </a>{' '}
            and I'll slot it in.
          </p>
        </div>

        <aside className="pt-8 flex flex-col items-center gap-3">
          <img
            src="/cover.jpg"
            alt="Cover of Cows, Men, Paddocks — Things Have Changed (Again)"
            className="w-40 sm:w-48 h-auto rounded shadow-md border border-black/10"
          />
          <p className="text-xs text-muted-foreground italic">
            Cows, Men, Paddocks — expected late 2026.
          </p>
        </aside>
      </div>
    </main>
  )
}

export default InviteDone
